import { Assignment, Business, ContactMail, HideImage, Inventory, People, Person, PhotoLibrary, Timeline, TrendingDown, TrendingUp } from "@mui/icons-material";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import DrawIcon from "@mui/icons-material/Draw";

// ─── Role Colors ─────────────────────────────────────────────────────────────
export const roleColors = {
    IC: "#0f3b63",
    BD: "#0d9488",
    DSP: "#f59e0b",
    BSP: "#38bdf8",
    'Sales Enabler': "#99f6e4",
    Dealer: "#1e293b",
    Studio: "#64748b",
};

// ─── Card Color Schemes ───────────────────────────────────────────────────────
export const cardColors2 = [
    { bg: "bg-red-100", text: "text-red-600", accent: "bg-red-600" },
    { bg: "bg-green-100", text: "text-purple-600", accent: "bg-purple-600" },
    { bg: "bg-orange-100", text: "text-cyan-600", accent: "bg-cyan-600" },
    { bg: "bg-cyan-100", text: "text-emerald-600", accent: "bg-emerald-600" },
    { bg: "bg-blue-100", text: "text-blue-600", accent: "bg-blue-600" },
];

// ─── Role Filter Options ──────────────────────────────────────────────────────
export const roleOpt = [
    { label: 'BSP', value: '3' },
    { label: 'DSP', value: '4' },
    { label: 'IC', value: '2' },
    { label: 'BD', value: '5' },
    { label: 'Sales Enabler', value: '6' },
    { label: 'Dealer', value: '7' },
    { label: 'Studio', value: '8' },
];

// ─── KPI Accent Palette ───────────────────────────────────────────────────────
export const KPI_ACCENTS = [
    { bar: '#0a2540', bg: 'rgba(10,37,64,0.06)', text: '#0a2540' },
    { bar: '#1a6b5e', bg: 'rgba(26,107,94,0.06)', text: '#1a6b5e' },
    { bar: '#f59e0b', bg: 'rgba(245,158,11,0.06)', text: '#b45309' },
    { bar: '#3b82f6', bg: 'rgba(59,130,246,0.06)', text: '#1d4ed8' },
    { bar: '#8b5cf6', bg: 'rgba(139,92,246,0.06)', text: '#6d28d9' },
    { bar: '#ec4899', bg: 'rgba(236,72,153,0.06)', text: '#be185d' },
    { bar: '#ef4444', bg: 'rgba(239,68,68,0.06)', text: '#b91c1c' },
    { bar: '#0ea5e9', bg: 'rgba(14,165,233,0.06)', text: '#0369a1' },
];

// ─── Chart.js Options Factory ─────────────────────────────────────────────────
export const chartOptions = (showScales, isHorizontal = false, enableLabels = false) => {
    return {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: isHorizontal ? 'y' : 'x',
        interaction: {
            mode: 'index',
            intersect: false,
        },
        layout: {
            padding: {
                top: !isHorizontal && enableLabels ? 20 : 0,
                right: isHorizontal && enableLabels ? 40 : 0
            }
        },
        scales: showScales ? {
            x: {
                grid: { display: false },
                ticks: { font: { family: 'Inter', size: 10 }, color: '#64748b' }
            },
            y: {
                grid: { color: '#f1f5f9' },
                ticks: { font: { family: 'Inter', size: 10 }, color: '#64748b' }
            }
        } : undefined,
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: '#0a2540',
                titleFont: { family: 'Inter', size: 11, weight: 'bold' },
                bodyFont: { family: 'Inter', size: 11 },
                padding: 10,
                borderRadius: 8,
            },
            nativeLabels: {
                enabled: enableLabels
            }
        }
    };
};


// ─── Deep Analysis Tabs ───────────────────────────────────────────────────────
export const DEEP_ANALYSIS_TABS = [
    { id: 'regionState', label: " Client's Region × State" },
    { id: 'catSeg', label: 'Category × Segment' },
    { id: 'userPerf', label: 'User Performance' },
    { id: 'monthCollection', label: 'Month × Collection' },
    { id: 'insights', label: 'Summary' },
];

// ─── Stats Categories Builder (call with analyticsSec1) ───────────────────────
export const buildStats = (analyticsSec1) => [
    {
        category: "Quotation Stage",
        items: [
            { title: "Enquiries", value: analyticsSec1?.kpis?.quotesInEnquiry || 0, icon: <ContactMail />, bg: "from-sky-500 to-sky-700" },
            { title: "In Pipeline", value: analyticsSec1?.kpis?.quotesInPipeline || 0, icon: <Timeline />, bg: "from-orange-500 to-orange-700" },
            { title: "Conversion", value: analyticsSec1?.kpis?.quotesInConversion || 0, icon: <TrendingUp />, bg: "from-green-500 to-green-700" },
            { title: "Lost", value: analyticsSec1?.kpis?.quotesInLost || 0, icon: <TrendingDown />, bg: "from-rose-500 to-rose-700" },
        ],
    },
    {
        category: "Users",
        items: [
            { title: "Total Users", value: analyticsSec1?.kpis?.totalUsers || 0, icon: <People />, bg: "from-blue-500 to-blue-700" },
            { title: "Active Users", value: analyticsSec1?.kpis?.activeUsers || 0, icon: <Person />, bg: "from-emerald-500 to-emerald-700" },
            { title: "Inactive Users", value: analyticsSec1?.kpis?.inactiveUsers || 0, icon: <PersonOffIcon />, bg: "from-blue-500 to-blue-700" },
        ],
    },
    {
        category: "Workspace",
        items: [
            { title: "Total Clients", value: analyticsSec1?.kpis?.totalClients || 0, icon: <Business />, bg: "from-indigo-500 to-indigo-700" },
            { title: "Total Quotations", value: analyticsSec1?.kpis?.totalQuotations || 0, icon: <Assignment />, bg: "from-amber-500 to-amber-700" },
            { title: "Total Drafts", value: analyticsSec1?.kpis?.totalDrafts || 0, icon: <DrawIcon />, bg: "from-yellow-500 to-green-700" },
        ],
    },
    {
        category: "Products",
        items: [
            { title: "Total Products", value: analyticsSec1?.kpis?.totalProducts || 0, icon: <Inventory />, bg: "from-purple-500 to-purple-700" },
            { title: "With Images", value: analyticsSec1?.kpis?.withImages || 0, icon: <PhotoLibrary />, bg: "from-teal-500 to-teal-700" },
            { title: "Without Images", value: analyticsSec1?.kpis?.withoutImages || 0, icon: <HideImage />, bg: "from-gray-500 to-gray-700" },
        ],
    },
];

export const chartNativeLabelsPlugin = {
    id: 'chartNativeLabels',
    afterDatasetsDraw(chart) {
        if (!chart.config.options.plugins?.nativeLabels?.enabled) return;

        const { ctx, data } = chart;
        const isHorizontal = chart.config.options.indexAxis === 'y';
        ctx.save();

        // Loop through ALL datasets instead of just index 0
        data.datasets.forEach((dataset, datasetIndex) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            
            // Skip hidden datasets
            if (meta.hidden) return;

            meta.data.forEach((bar, index) => {
                const value = dataset.data[index];
                if (value === undefined || value === null) return;

                const formattedValue = value.toLocaleString();
                let xPos, yPos;

                if (isHorizontal) {
                    // Horizontal Bars
                    xPos = bar.x + 8;
                    yPos = bar.y + 4;
                    ctx.textAlign = 'left';
                    ctx.fillStyle = '#475569';
                } else {
                    // Vertical Bars
                    xPos = bar.x;
                    yPos = bar.y - 8;
                    ctx.textAlign = 'center';
                    ctx.fillStyle = '#1e293b';
                }

                ctx.font = 'bold 10px monospace';
                ctx.fillText(formattedValue, xPos, yPos);
            });
        });

        ctx.restore();
    }
};